var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 69,
    fill: "none",
    viewBox: "0 0 59 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M52.742 23.931c0 4.273 1.13 6.792 3.615 9.695 1.884 2.139 2.486 4.884 2.486 7.862 0 2.974-.978 5.798-2.936 8.09-2.563 2.75-6.178 4.504-9.868 4.81-5.346.455-10.696.839-16.117.839-5.425 0-10.771-.23-16.118-.84-3.693-.305-7.308-2.06-9.868-4.808C1.978 47.286.997 44.462.997 41.488c0-2.978.606-5.723 2.486-7.862C6.046 30.723 7.1 28.205 7.1 23.931v-1.45c0-5.723 1.427-9.465 4.366-13.129C15.837 4.01 22.84.805 29.77.805h.305c7.078 0 14.308 3.359 18.603 8.931 2.787 3.588 4.065 7.173 4.065 12.745v1.45ZM19.962 62.26c0-1.714 1.573-2.498 3.027-2.834 1.701-.36 12.067-.36 13.768 0 1.454.335 3.026 1.12 3.026 2.834-.084 1.631-1.041 3.077-2.364 3.996a12.366 12.366 0 0 1-5.83 2.488c-1.163.15-2.306.154-3.429 0a12.31 12.31 0 0 1-5.83-2.492c-1.326-.915-2.283-2.36-2.367-3.992Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c8ee2faf0f97e48de47be16c20c27bb2.svg";
export { ForwardRef as ReactComponent };